import React, { ReactNode } from 'react';
import { JSONLD } from '../JSONLD';
export type Video = {
  embedUrl: string;
};
export type ArticleStructuredDataProps = {
  value: {
    article: ReactNode;
    breadcrumbs: ReactNode;
    videos: Video[];
  };
};
export const ArticleStructuredData = ({
  value
}: ArticleStructuredDataProps) => <>
    {value.article && <JSONLD>
        {value.article}
      </JSONLD>}
    {value.breadcrumbs && <JSONLD>
        {value.breadcrumbs}
      </JSONLD>}
    {value.videos && value.videos.filter((video: {
    embedUrl: string;
  }) => video.embedUrl).map((video: {
    embedUrl: string;
  }) => <JSONLD key={video.embedUrl}>
            {video}
          </JSONLD>)}
  </>;